import { SourcesList } from 'ai-components-ui-library/components/informative/sources/SourcesList';
import { CrmDataSourceButton } from './sourceButtons/CrmDataSourceButton';
import { WebDataSourceButton } from './sourceButtons/WebDataSourceButton';
import { jsx as _jsx } from "react/jsx-runtime";
export const CitationSourceButton = ({
  source
}) => {
  switch (source.__typename) {
    case 'com.hubspot.custom.enrichment.models.CrmDataCitationBase':
      return /*#__PURE__*/_jsx(CrmDataSourceButton, {
        source: source,
        children: props => /*#__PURE__*/_jsx(SourcesList.Source, Object.assign({}, props))
      });
    case 'com.hubspot.custom.enrichment.models.WebDataCitation':
      return /*#__PURE__*/_jsx(WebDataSourceButton, {
        source: source,
        children: props => /*#__PURE__*/_jsx(SourcesList.Source, Object.assign({}, props))
      });
    default:
      // TODO: Uncomment this once we are no longer in active development for citations and we can expect the types to be more stable.
      // assertUnreachable(source);
      return null;
  }
};